export class DefaultData {
    static IMAGE_URL_FALLBACK = "https://upload.wikimedia.org/wikipedia/commons/b/b1/Missing-image-232x150.png?20180322092056"
}